import axios from "../lib/axios-config";
const signUp = (payload)=>axios.post("/auth/signup", payload);
const logIn = (payload)=>axios.post("/auth/login", payload);
const forgotPassword = (payload)=>axios.post("/auth/forgot-password", payload);
const resetPassword = (payload)=>axios.post("/auth/reset-password", payload);
const verifyCode = (payload)=>axios.post("/auth/verify-code", payload);
const sendVerificationCode = (payload)=>axios.post("/auth/send-verification-code", payload);
const checkUserExists = (payload)=>axios.post("/auth/check-user-exists", payload);
export const AuthApi = {
    signUp,
    logIn,
    forgotPassword,
    resetPassword,
    verifyCode,
    sendVerificationCode,
    checkUserExists
};
